import React from 'react';
import styles from './AppointmentTable.module.css';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import timeAgo from '@/ctUtlis/timeAgo';

export default function CloseAlert({ handleClose, time }) {
  return (
    <div className={styles.alert}>
      <div className={styles.alertClose} onClick={handleClose}>
        <ReactSVG
          src={Icons.close}
          beforeInjection={(svg) => {
            svg.querySelectorAll('path').forEach((path) => {
              path.setAttribute('stroke', 'white');
            });
          }}
        />
      </div>
      <div className="flex-col gap-2 lg:gap-0 lg:flex-row flex items-center">
        <div className={styles.alertpicContainer}>
          <ReactSVG src={Icons.closeCircle} />
        </div>
        <div className={styles.column}>
          <span className={styles.boldText}>Closed for Receiving</span>
          <span style={{ marginLeft: '3px' }}>
            Last checked {timeAgo(time)}
          </span>
        </div>
      </div>
      <span className={styles.link}>
        <ReactSVG src={Icons.screenshoteye} className={styles.screenshoteye} />
        View Screenshot
      </span>
    </div>
  );
}
